import styled from 'styled-components'
import { ColorSwatchCircle } from '../Blocks'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { useMemo } from 'react'

const ColorSwatchContainer = ({
  section,
  width = '100%',
  padding = '4px',
  flex = 'wrap',
  gap = '13px',
  limit = 'default',
  texture = true
}) => {
  const snap = useSnapshot(state.current)
  const choices = snap.choices

  const colors = useMemo(() => {
    // console.log(limit)
    switch (limit) {
      case 'reinforced':
        return snap.reinforcedColors
      case 'regular':
      case 'nopattern':
        return snap.colors.slice(0, snap.colorsExcPatterns)
      case 'numbers':
        return snap.numberColors
      case 'default':
        return snap.colors
      default:
        return snap.colors
    }
  }, [limit, snap.reinforcedColors, snap.colors, snap.colorsExcPatterns])

  const setColor = (location, color) => {
    switch (location) {
      case 'sidePanels':
        // console.log('settign side colors')
        state.current.choices.sidePanels.selected = {
          mode: snap.status.settingReinforcedSides ? 'reinforced' : 'regular',
          name: color.name,
          hex: color.hex ?? null,
          src: color.src ?? null,
          abrv: color.abrv ?? null,
        }
        break
      case 'ribs':
        // console.log("ribb")

        if (snap.choices.ribs.selected.mode === 'single') {
          state.current.choices.ribs.selected.rib.forEach((rib) => {
            rib.name = color.name
            rib.hex = color.hex ?? null
            rib.src = color.src ?? null
            rib.abrv = color.abrv ?? null
          })
        } else {
          state.current.choices.ribs.selected.rib[snap.status.currentRib - 1] = {
            name: color.name,
            hex: color.hex ?? null,
            src: color.src ?? null,
            abrv: color.abrv ?? null,
          }
        }
        break
      case 'raceNumber':
        // console.log("raceNumber")

        if (snap.status.numberSelectMode === 'color') {
          state.current.choices.raceNumber.selected = {
            mode: 'number',
            name: color.name,
            outlineName: snap.choices.raceNumber.selected.outlineName,
            hex: color.hex ?? null,
            outlineHex: snap.choices.raceNumber.selected.outlineHex,
            src: color.src ?? null,
            abrv: color.abrv ?? null,
            number: snap.choices.raceNumber.selected.number,
            font: snap.choices.raceNumber.selected.font,
          }
        } else {
          if (snap.status.numberSelectMode === 'outline') {
            state.current.choices.raceNumber.selected = {
              mode: 'number',
              name: snap.choices.raceNumber.selected.name,
              outlineName: color.name,
              hex: snap.choices.raceNumber.selected.hex,
              outlineHex: color.hex ?? null,
              src: color.src ?? null,
              abrv: color.abrv ?? null,
              number: snap.choices.raceNumber.selected.number,
              font: snap.choices.raceNumber.selected.font,
            }
          }
        }

        break
      // case 'superBadgeName':
      // case 'superBadgeNum':
      //   state.current.choices.superBadge.selected.hex = color.hex ?? null
      //   break
      case 'superBadge':
        // console.log("super badge color set to: ", color.name)
        const selected = state.current.choices.superBadge.selected
        selected.mode = 'badge'
        selected.name = color.name
        selected.hex = color.hex ?? null
        // subMode, number, riderName, sizes, fonts left untouched — no need to reassign
        break


      default:
        state.current.choices[location].selected = {
          mode: choices[location].selected.mode,
          name: color.name,
          hex: color.hex ?? null,
          src: color.src ?? null,
          abrv: color.abrv ?? null,
        }
    }
  }

  // const setRibColor = (location, color) => {

  // }

  return (
    <Wrap $flex={flex} $gap={gap} $padding={padding} $width={width}>
      {colors.map((color) => (
        <ColorSwatchCircle
          section={section}
          key={`side-color-${color.name}`}
          src={color.src}
          tag={color.name}
          color={color.hex}
          texture={texture}
          handleClick={() => {
            setColor(section, color)
          }}
        />
      ))}
    </Wrap>
  )
}

export default ColorSwatchContainer

const Wrap = styled.div`
  gap: ${(props) => props.$gap};
  z-index: 10;
  display: flex;
  justify-content: center;
  padding: ${(props) => props.$padding};
  flex-wrap: ${(props) => props.$flex};
  width: 100%;

  @media (width > 800px) {
    flex-wrap: ${(props) => props.$flex};
  }
`
